import { render } from "./PriceRangeSlider.vue?vue&type=template&id=a2a1e40e&ts=true"
import script from "./PriceRangeSlider.vue?vue&type=script&lang=ts"
export * from "./PriceRangeSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/waga/Projects/breil/wp-content/themes/breil/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__